 


import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import MyItemCard from "../components/MyItemCard";
import ItemGrid from "../components/ItemGrid";
import PenaltyApprovalModal from "../components/PenaltyApprovalModal";
import CompleteProfileModal from "../components/CompleteProfileModal"; 

const TABS = { ALL: "all", LENT: "lent", BORROWED: "borrowed" };

function MyItems() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.newOrder ? TABS.BORROWED : TABS.ALL);
  const [items, setItems] = useState([]);
  const [penaltyData, setPenaltyData] = useState(null);
  const [loading, setLoading] = useState(true);

  // User States
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [returnOtpMap, setReturnOtpMap] = useState({}); 

  // 🔥 NAYA STATE: Taaki page turant refresh ho bina reload kiye
  const [isProfileVerified, setIsProfileVerified] = useState(!!(user?.address && user?.idProof));

  const token = localStorage.getItem("token");

//   useEffect(() => { fetchData(); }, [activeTab]);
useEffect(() => { 
    fetchData(); 
    checkFreshUser(); // Page load hote hi fresh data laayega
  }, [activeTab]);

  const checkFreshUser = async () => {
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/user/profile", {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      
      if (data.user) {
        setUser(data.user); // State update
        localStorage.setItem("user", JSON.stringify(data.user)); // Local storage update
        
        // Agar address aur ID proof dono hain, toh OTP hamesha ke liye Unlock!
        if (data.user.address && data.user.idProof) {
          setIsProfileVerified(true);
        }
      }
    } catch (err) {
      console.error("User fetch error:", err);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let itemsUrl = "";
      if (activeTab === TABS.ALL) itemsUrl = "https://borrowhub-backend.onrender.com/api/items/my-items";
      else if (activeTab === TABS.LENT) itemsUrl = "https://borrowhub-backend.onrender.com/api/items/lent-out";
      else if (activeTab === TABS.BORROWED) itemsUrl = "https://borrowhub-backend.onrender.com/api/items/borrowed";

      const resItems = await fetch(itemsUrl, { headers: { Authorization: `Bearer ${token}` } });
      const dataItems = await resItems.json();
      
      const rawItems = dataItems.items || [];

      // Penalty check logic 
      const mergedItems = rawItems.map((item) => {
        let penaltyObj = null;
        if (item.status === "disputed_in_court") {
            penaltyObj = { _id: item._id, status: "disputed", totalPenalty: item.mandate?.maxDeductibleAmount || 0, lenderComment: "Admin Case Active" };
        }
        return { ...item, penaltyRequest: penaltyObj };
      });
      setItems(mergedItems);

    } catch (err) { console.error("MyItems fetch error", err); } 
    finally { setLoading(false); }
  };

  // 🔥 TICKET LOGIC (Sirf 'reserved' and Borrower)
  const activeTickets = items.filter(i => {
      if (i.status !== "reserved") return false;
      const itemBorrowerId = typeof i.borrowedBy === "object" ? i.borrowedBy?._id : i.borrowedBy;
      return itemBorrowerId?.toString() === user?._id?.toString();
  });

  // 🔥 GRID LIST
  const gridItems = items.filter(i => {
      if (i.status !== "reserved") return true;
      if (i.status === "reserved" && (i.owner === user?._id || i.owner?._id === user?._id)) {
          return true;
      }
      return false;
  });

  // 🔥 PROFILE HANDLER
  const handleProfileSaved = (updatedUser) => {
      setUser(updatedUser); 
      localStorage.setItem("user", JSON.stringify(updatedUser)); 
      setIsProfileVerified(true); // 🚀 Isse OTP turant dikhega!
      setShowProfileModal(false);
  };

  const handleReturnClick = (itemId) => {
      const mockReturnOtp = itemId.slice(-4).toUpperCase();
      setReturnOtpMap(prev => ({ ...prev, [itemId]: mockReturnOtp }));
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        
        {/* 🔥🔥 SECTION 1: TICKETS (Sirf Borrower ke liye) 🔥🔥 */}
        {activeTickets.length > 0 && activeTickets.map(ticket => {
            // 🔥 NAYA CHECK: Agar usne form bhar diya hai, toh ticket.borrowedBy check mat karo, bas isProfileVerified dekho
            const canShowOtp = isProfileVerified || (ticket.borrowedBy?.address && ticket.borrowedBy?.idProof);

            return (
                <div key={ticket._id} className="card border-0 shadow-lg mb-3 overflow-hidden animate__animated animate__fadeInDown" 
                     style={{ background: "linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%)", borderLeft: "6px solid #16a34a" }}>
                    <div className="card-body p-0">
                        <div className="row g-0 align-items-center">
                            <div className="col-4 col-md-2">
                                 <img src={ticket.images?.[0]?.url || ticket.images?.[0] || "https://via.placeholder.com/150"} alt="Item" style={{ width: "100%", height: "120px", objectFit: "cover" }} />
                            </div>
                            <div className="col-8 col-md-10 p-3">
                                <h5 className="text-success fw-bold mb-1">🎟️ Pickup Pending: {ticket.title}</h5>
                                
                                <div className="d-flex align-items-center gap-3 mt-2">
                                    <div className="bg-white px-3 py-2 rounded border border-success border-dashed min-w-[120px] text-center">
                                        <span className="small text-uppercase fw-bold text-muted d-block" style={{fontSize: "0.7rem"}}>Pickup OTP</span>
                                        
                                        {canShowOtp ? (
                                            <span className="h4 fw-bold text-success m-0 letter-spacing-1">{ticket.pickupOtp}</span>
                                        ) : (
                                            <button 
                                                className="btn btn-sm btn-success fw-bold py-1 px-2" 
                                                onClick={() => setShowProfileModal(true)}
                                            >
                                                🔓 Unlock OTP
                                            </button>
                                        )}
                                    </div>

                                    <div className="text-muted small" style={{lineHeight: "1.2"}}>
                                        {canShowOtp ? (
                                           <>👉 Show OTP to Lender <br/> And Tell To Write In Handover Section For Start Renting</>
                                        ) : (
                                            <b className="text-danger">⚠️One Time Profile Verification<br/> to see OTP.</b>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        })}

        {/* TABS */}
        <div className="d-flex gap-4 border-bottom pb-2">
          <Tab label="All Items" active={activeTab === TABS.ALL} onClick={() => setActiveTab(TABS.ALL)} />
          <Tab label="Lent Out" active={activeTab === TABS.LENT} onClick={() => setActiveTab(TABS.LENT)} />
          <Tab label="Borrowed" active={activeTab === TABS.BORROWED} onClick={() => setActiveTab(TABS.BORROWED)} />
        </div>

        <div className="mt-4">
            <h4 className="fw-bold">{activeTab === TABS.BORROWED ? "Items I Borrowed" : activeTab === TABS.LENT ? "Items I Lent" : "My Items"}</h4>
        </div>

        {loading && <div className="text-center mt-5"><div className="spinner-border text-success" /></div>}

        {!loading && gridItems.length === 0 && activeTickets.length === 0 && (
            <div className="text-center mt-5 text-muted">
                <p>No items found.</p>
            </div>
        )}

        {/* 🔥🔥 SECTION 2: GRID 🔥🔥 */}
        {!loading && gridItems.length > 0 && (
          <ItemGrid
            items={gridItems} 
            type={activeTab}
            renderItem={(item) => (
               <div key={item._id} className="position-relative">
                  <MyItemCard 
                    item={item} 
                    type={activeTab === TABS.ALL ? (item.owner === user?._id || item.owner?._id === user?._id ? "lent" : "borrowed") : activeTab} 
                    onRefresh={fetchData} 
                  />

                  {(item.status === "borrowed") && (
                      <div className="mt-2">
                          {!returnOtpMap[item._id] ? (
                              <button className="btn btn-dark w-100 fw-bold shadow-sm" onClick={() => handleReturnClick(item._id)}>↩️ Return Item</button>
                          ) : (
                              <div className="bg-warning bg-opacity-25 border border-warning rounded p-2 text-center animate__animated animate__flipInX">
                                  <small className="text-dark fw-bold d-block">Return OTP</small>
                                  <h3 className="m-0 fw-bold text-dark letter-spacing-2">{returnOtpMap[item._id]}</h3>
                              </div>
                          )}
                      </div>
                  )}
               </div>
            )}
          />
        )}
      </div>

      {penaltyData && <PenaltyApprovalModal request={penaltyData} onClose={() => setPenaltyData(null)} onResolved={() => { setPenaltyData(null); fetchData(); }} />}
      
      {showProfileModal && (
        <CompleteProfileModal 
            user={user} 
            onClose={() => setShowProfileModal(false)} 
            onSave={handleProfileSaved} 
        />
      )}
    </>
  );
}

function Tab({ label, active, onClick }) {
  return (
    <div onClick={onClick} style={{ cursor: "pointer", paddingBottom: "8px", borderBottom: active ? "3px solid #16a34a" : "none", color: active ? "#16a34a" : "#555", fontWeight: 600 }}>
      {label}
    </div>
  );
}

export default MyItems;